// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	angular.module("swurveys.maker")
		.controller("adminWallController", Handler)
	.filter('trustAsResourceUrl', ['$sce', function($sce) {
		//This is so we can set iframe URL from angular
    return function(val) {
        return $sce.trustAsResourceUrl(val);
    };
}]);

	function Handler($scope, swurveyAdminService, loggedInUser, $routeParams, liveReloadService, $timeout) {
		$scope.currentSwurveyList = {};

    liveReloadService.init(AWS.config.credentials, "a " + new Date().getTime(), "prod/#", function(newModel) {
			var id = newModel.swurveyId;
			if($scope.currentSwurveyList[id])
			{
				$timeout.cancel($scope.currentSwurveyList[id]);
			}
			$timeout(function(){
				$scope.currentSwurveyList[id] = {
					timer :$timeout(function(){
						console.log("removing ", id);
						delete $scope.currentSwurveyList[id];
					}, 300000),
					userId : newModel.userId,
					model : newModel.payload
			}
		});

		}, '/#');




	}
}());
